module.exports = __webpack_public_path__ + "static/media/pc_icon_close.f6e54a4d.svg";